import i18n from "i18n/i18n";

export enum EquipmentInspectionStatus {
    INSPECTED = "INSPECTED",
    NOT_INSPECTED = "NOT_INSPECTED",
    OUT_OF_OPERATION = "OUT_OF_OPERATION",
    INACCESSIBLE = "INACCESSIBLE",
    OTHER = "OTHER",
}

const EQUIPMENT_INSPECTION_STATUS_I18N_KEYS: Record<EquipmentInspectionStatus, string> = {
    [EquipmentInspectionStatus.INSPECTED]: "pages.thermography.equipmentInspectionStatus.inspected",
    [EquipmentInspectionStatus.NOT_INSPECTED]: "pages.thermography.equipmentInspectionStatus.notInspected",
    [EquipmentInspectionStatus.OUT_OF_OPERATION]: "pages.thermography.equipmentInspectionStatus.outOfOperation",
    [EquipmentInspectionStatus.INACCESSIBLE]: "pages.thermography.equipmentInspectionStatus.inaccessible",
    [EquipmentInspectionStatus.OTHER]: "pages.thermography.equipmentInspectionStatus.other",
};

export const EquipmentInspectionStatusLabel = new Proxy(
    EQUIPMENT_INSPECTION_STATUS_I18N_KEYS as Record<EquipmentInspectionStatus, string>,
    {
        get(target, prop: string) {
            const key = (target as Record<string, string>)[prop];
            return key ? i18n.t(key, { ns: "translation" }) : undefined;
        },
    }
);
